"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { InProcessSupervisionQuotaModel } from "@/models/paymentModels/PaymentPurchase.model";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
const vipIcon = require("@/assets/midsafety/yundun.png");
const aliPayIcon = require("@/assets/img/pay_zfb.png");
const wechatPayIcon = require("@/assets/img/pay_wx.png");
import { Debounce } from "vue-debounce-decorator";
import DateFormat from "@/framework/timeformatter";
import Question from "@/components/Question.vue";
let PayAdditionalPurchase = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.pageLoading = false;
    this.payLoading = false;
    //VIP图标
    this.vip_icon = vipIcon;
    // 支付图标
    this.alipay_icon = aliPayIcon;
    this.wechat_icon = wechatPayIcon;
    // 套餐相关数据
    this.productList = [];
    this.selectedProduct = new InProcessSupervisionQuotaModel();
    // 计算属性
    // 原价
    this.originalPrice = 0;
    // 折后价
    this.discountPrice = 0;
    // 应付金额
    this.payPrice = 0;
    // 已有监管名额数量
    this.totalQuota = 0;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getProducts();
      yield this.getUsedQuota();
      yield this.calculations();
    });
  }
  changeQuota() {
    return __async(this, null, function* () {
      this.payLoading = true;
      yield this.calculations();
    });
  }
  getUsedQuota() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/regulation-quota-statistics`);
        this.totalQuota = response.data.totalQuota;
      } catch (error) {
      }
    });
  }
  deteFormat(time) {
    if (time === 0 || time === null) {
      return "--";
    }
    return DateFormat.dateformatterDay(DateFormat.check(time));
  }
  calculations() {
    return __async(this, null, function* () {
      try {
        yield this.getGoldbean();
        let calculateData = {
          discounts: [],
          coin: this.selectedProduct.paymentGoldbeanUsed,
          quantity: this.selectedProduct.selectedAdditionalQuota,
          payType: this.selectedProduct.paymentMethod,
          goodsSpecGuid: this.selectedProduct.id,
          type: "IN_PROCESS_SUPERVISION_QUOTA_NEW"
        };
        let response = yield API.post(`api://base.auth.pro/v1/calculate`, calculateData);
        this.calculationTidy(response.data);
        this.originalPrice = response.data.originalPrice;
        this.discountPrice = response.data.discountPrice;
        this.payPrice = response.data.payPrice;
      } catch (error) {
      } finally {
        this.payLoading = false;
      }
    });
  }
  calculationTidy(data) {
    return __async(this, null, function* () {
      this.selectedProduct.paymentGoldbeanUsed = this.selectedProduct.paymentGoldbeanUsed ? this.selectedProduct.paymentGoldbeanUsed : 0;
      this.selectedProduct.paymentGoldbeanLeft = this.selectedProduct.paymentGoldbeanCoins - data.coin;
      this.selectedProduct.paymentGoldbeanLimit = Math.min(
        data.maxCoin,
        this.selectedProduct.paymentGoldbeanCoins
      );
      if (this.selectedProduct.paymentGoldbeanUsed > this.selectedProduct.paymentGoldbeanLimit) {
        this.selectedProduct.paymentGoldbeanUsed = this.selectedProduct.paymentGoldbeanLimit;
      }
    });
  }
  getGoldbean() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v7/payment/account/coins`
        );
        this.selectedProduct.paymentGoldbeanCoins = response.data.account_coins.coins;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  discountChange() {
    return __async(this, null, function* () {
      this.payLoading = true;
      yield this.calculations();
    });
  }
  payForGoldbean() {
    return __async(this, null, function* () {
      try {
        this.payLoading = true;
        if (this.selectedProduct.paymentGoldbeanCoins && this.selectedProduct.paymentGoldbeanCoins > 0) {
          if (this.selectedProduct.paymentGoldbeanLimit >= this.selectedProduct.paymentGoldbeanLeft) {
            this.selectedProduct.paymentGoldbeanUsed = this.selectedProduct.paymentGoldbeanLeft;
          } else {
            this.selectedProduct.paymentGoldbeanUsed = this.selectedProduct.paymentGoldbeanLimit;
          }
          yield this.calculations();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  toCost() {
    let router = this.$router.resolve("/cost");
    window.open(router.href, "_blank");
  }
  selectPayment(method) {
    this.selectedProduct.paymentMethod = method;
  }
  // 获取商品列表
  getProducts() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v8/goods/in_process_supervision_quota/purchase`);
        this.productList = response.data.datas;
        this.selectedProduct = this.productList[0];
        this.selectedProduct.selectedAdditionalQuota = 1;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 去支付
  payNow() {
    return __async(this, null, function* () {
      this.payLoading = true;
      yield this.createOrder();
    });
  }
  createOrder() {
    return __async(this, null, function* () {
      try {
        const orderData = {
          "callback": "https://app.kuajingvs.com/paymentcomplete",
          "discounts": [
            {
              "type": "point",
              "value": this.selectedProduct.paymentGoldbeanUsed
            }
          ],
          "pay_type": this.selectedProduct.paymentMethod,
          "product": {
            "goods_spec_guid": this.selectedProduct.id
          },
          "quantity": this.selectedProduct.selectedAdditionalQuota,
          "user_input": {}
        };
        let response = yield API.post(`api://base.auth/api/v8/orders/in_process_supervision_quota/pay`, orderData);
        console.log(response.data);
        this.selectedProduct.paymentGoldbeanUsed = 0;
        let model = response.data;
        if (model.order) {
          model.gift = model.order.pay_money <= 0;
        } else {
          model.gift = false;
        }
        let _order_id = model.order.id;
        let _qr_url = model.url;
        let _gift = model.gift;
        switch (this.selectedProduct.paymentMethod) {
          case "alipay":
            this.$router.push({
              name: "PaymentPurchaseConfirmation",
              query: {
                t: "alipay",
                r: "",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: "buy_quota"
              }
            });
            break;
          case "wxpay":
            this.$router.push({
              name: "PaymentPurchaseConfirmation",
              query: {
                t: "wechat",
                r: "",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: "buy_quota"
              }
            });
            break;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.payLoading = false;
      }
    });
  }
};
__decorateClass([
  Debounce(400)
], PayAdditionalPurchase.prototype, "calculations", 1);
__decorateClass([
  Debounce(400)
], PayAdditionalPurchase.prototype, "createOrder", 1);
PayAdditionalPurchase = __decorateClass([
  Component({
    components: {
      Question
    },
    filters: {
      numFilter: (value) => {
        if (value === "-") {
          return value;
        }
        return Number(value).toFixed(2);
      }
    }
  })
], PayAdditionalPurchase);
export {
  PayAdditionalPurchase as default
};
